import { render, staticRenderFns } from "./HostSpecs.vue?vue&type=template&id=60ca2310&scoped=true&"
import script from "./HostSpecs.vue?vue&type=script&lang=js&"
export * from "./HostSpecs.vue?vue&type=script&lang=js&"
import style0 from "./HostSpecs.vue?vue&type=style&index=0&id=60ca2310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca2310",
  null
  
)

export default component.exports